<div class='modal-header'>
  <h4 class='modal-title'>
    {{title}}
  </h4>
  <a class='clickable' title='Schließen' aria-label='Close' (click)='modal.close(false)'>
    <span><i class='fas fa-times'></i></span>
  </a>
</div>

<div class='modal-body'>
  <form [formGroup]="form">
    <div class='row'>
      <div class='col'>
        <label for="month">Monat*</label>
        <select class="form-control form-control-sm" formControlName="month" required>
          <option *ngFor="let month of months" [value]="month.value">
            {{month.label}}
          </option>
        </select>
        <form-error [formErrors]="[]" [control]="form.controls.month"></form-error>
      </div>

      <div class='col'>
        <label for="year">Jahr*</label>
        <select class="form-control form-control-sm" formControlName="year" required>
          <option *ngFor="let year of years" [value]="year">
            {{year}}
          </option>
        </select>
        <form-error [formErrors]="[]" [control]="form.controls.year"></form-error>
      </div>

    </div>
  </form>
</div>

<div class='modal-footer'>
  <button class='btn btn-success' type='button' (click)="submit()">
    Suchen
  </button>

  <button class='btn btn-dark' (click)='modal.close(false)'>
    Abbrechen
  </button>
</div>